import styled from '@emotion/styled'
import {Done as DoneIcon, MoreVert as MoreVertIcon} from '@mui/icons-material'
import React from 'react'
import FlatButton from '../../../../components/FlatButton'
import ProviderActions from '../../../../components/ProviderActions'
import RowInfo from '../../../../components/Row/RowInfo'
import RowInfoCopy from '../../../../components/Row/RowInfoCopy'
import useBreakpoint from '../../../../hooks/useBreakpoint'
import {cardShadow} from '../../../../styles/elevation'
import {PALETTE} from '../../../../styles/paletteV3'
import {Breakpoint, Layout} from '../../../../types/constEnums'

const MenuButton = styled(FlatButton)({
  borderColor: PALETTE.SLATE_400,
  color: PALETTE.SLATE_700,
  fontSize: 14,
  fontWeight: 600,
  minWidth: 36,
  paddingLeft: 0,
  paddingRight: 0
})

const SmallMenuButton = styled(MenuButton)({
  minWidth: 30
})

const StatusWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  paddingRight: 25
})

const StatusLabel = styled('div')({
  color: PALETTE.SLATE_700,
  fontSize: 14,
  fontWeight: 600,
  paddingLeft: 6
})

const StatusIcon = styled('div')({
  svg: {
    fontSize: 18
  },
  width: 18,
  height: 18,
  color: PALETTE.SUCCESS_LIGHT
})

const MenuSmallIcon = styled(MoreVertIcon)({
  svg: {
    fontSize: 18
  },
  width: 18,
  height: 18
})

const ProviderName = styled('div')({
  color: PALETTE.SLATE_700,
  fontSize: 16,
  fontWeight: 600,
  lineHeight: '24px',
  alignItems: 'center',
  display: 'flex',
  marginRight: 16,
  verticalAlign: 'middle'
})

const ProviderCard = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  borderRadius: 4,
  boxShadow: cardShadow,
  flexShrink: 0,
  justifyContent: 'flex-start',
  margin: '16px 0',
  padding: 0,
  position: 'relative',
  width: '100%'
})

const CardTop = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: Layout.ROW_GUTTER
})

const HowItWorksLink = styled('a')({
  color: PALETTE.SKY_500,
  cursor: 'pointer',
  textDecoration: 'underline',
  ':hover, :focus, :active': {
    color: PALETTE.SKY_600
  }
})














const ProviderRowBase = (props) => {
  const {
    connectButton,
    connected,
    error,
    togglePortal,
    menuRef,
    providerName,
    providerDescription,
    providerLogo,
    seeHowItWorksUrl,
    children
  } = props
  const isDesktop = useBreakpoint(Breakpoint.SIDEBAR_LEFT)
  return (
    React.createElement(ProviderCard, null
      , React.createElement(CardTop, null
        , providerLogo
        , React.createElement(RowInfo, null
          , React.createElement(ProviderName, null, providerName)
          , React.createElement(RowInfoCopy, null
            , providerDescription, ".", ' '
            , seeHowItWorksUrl && (
              React.createElement(React.Fragment, null
                , React.createElement(HowItWorksLink, { href: seeHowItWorksUrl, target: "_blank", rel: "noreferrer",}, "See how it works"

                ), "."

              )
            )
          )
          , !!error && (
            React.createElement('div', { className: "text-sm text-tomato-500 [&_a]:font-semibold [&_a]:text-tomato-500 [&_a]:underline"    ,}
              , error
            )
          )
        )
        , React.createElement(ProviderActions, null
          , !connected && connectButton
          , connected && (
            React.createElement(React.Fragment, null
              , isDesktop ? (
                React.createElement(React.Fragment, null
                  , React.createElement(StatusWrapper, null
                    , React.createElement(StatusIcon, null
                      , React.createElement(DoneIcon, null )
                    )
                    , React.createElement(StatusLabel, null, "Connected")
                  )
                  , React.createElement(SmallMenuButton, { onClick: togglePortal, ref: menuRef,}
                    , React.createElement(MenuSmallIcon, null
                      , React.createElement(MoreVertIcon, null )
                    )
                  )
                )
              ) : (
                React.createElement(MenuButton, { onClick: togglePortal, ref: menuRef,}
                  , React.createElement(MoreVertIcon, null )
                )
              )
            )
          )
        )
      )
      , children
    )
  )
}

export default ProviderRowBase
